import { render } from "./AvatarModal.vue?vue&type=template&id=1cd51a01&scoped=true"
import script from "./AvatarModal.vue?vue&type=script&lang=js"
export * from "./AvatarModal.vue?vue&type=script&lang=js"

import "./AvatarModal.vue?vue&type=style&index=0&id=1cd51a01&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.18_vue@3.5.18_webpack@5.101.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd51a01"]])

export default __exports__